import React from 'react';
import { connect } from 'react-redux';
import Loader from 'react-loader';

import QuickSightAPI from '../../common/domain/lambda/fn-quicksight-url';
import DuckMainData from '../../common/domain/lambda/fn-dashboard-main-data/ducks/get';

// import OAuth from '../../helpers/oauth';

import Logger from '../../helpers/logger';

class QuickSightDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      url: '',
      loaded: false
    };
  }

  componentDidMount() {
    // this.getUrl();
    const { getWorkspaces } = this.props;
    getWorkspaces();
    this.getUrl();

    // update any menu related with user info
    // OAuth.user().then(user => {
    // const username = user ? user.attributes.email || '' : '';
    // console.log(username);
    //   if (
    //     !(
    //       username === 'ccastro@nekki.cl' ||
    //       username === 'ccastro' ||
    //       username === 'ajaldin@nekki.cl' ||
    //       username === 'ajaldin@nekki.us' ||
    //       username === 'ajaldin' ||
    //       username === 'mshoji@nekki.cl' ||
    //       username === 'mshoji@mymoodbit.com' ||
    //       username === 'mshoji'
    //     )
    //   ) {
    //     // Simulate an HTTP redirect:
    //     console.log('Not Authorized');
    //     window.location.replace('/dashboard');
    //   }
    // });
  }

  getUrl = () => {
    const { workspaces } = this.props;
    Logger.info('Available Workspaces', workspaces);
    const workspaceIds = workspaces.data.map(item => item.id);

    Logger.info('Sending', workspaceIds);

    this.setState({ loaded: false });

    QuickSightAPI.get({
      dashboardId: 'c46db750-2355-4ac4-a121-8bbcd42d45ba', // 'c56ee21e-6b93-41ba-99ef-1d36b6e748ac',
      workspaceIds
    }).then(url => {
      Logger.info('Got Url', url);
      this.setState({ url });
    });
  };

  hideLoadingSpinner = () => {
    Logger.info('Dashboard Iframe Loaded');
    this.setState({ loaded: true });
  };

  render() {
    const { url, loaded } = this.state;

    if (!loaded) {
      setTimeout(() => {
        this.hideLoadingSpinner();
      }, 5000);
    }

    return (
      <div>
        <Loader loaded={loaded} />
        <iframe
          title="quicksight"
          style={{ width: '100%', height: '700px', border: 'none' }}
          src={url}
          // for some reason this is not triggering, disabled for now
          // onLoad={this.hideLoadingSpinner}
        />
        <br />
        {/* <table style={{ border: 'none', width: '100%' }}>
          <tr>
            <th>Resolution Word Cloud</th>
            <th>Description Word Cloud</th>
          </tr>
          <tr>
            <td>
              <img alt="Chart" src="/latam/freqwordres.png" />
            </td>
            <td>
              <img alt="Chart" src="/latam/freqworddes.png" />
            </td>
          </tr>
        </table>
        <br />
        <table style={{ border: 'none', width: '100%' }}>
          <tr>
            <th>Resolution Distribution</th>
            <th>Description Distribution</th>
          </tr>
          <tr>
            <td>
              <img alt="Chart" src="/latam/distributionres.png" />
            </td>
            <td>
              <img alt="Chart" src="/latam/distributiondes.png" />
            </td>
          </tr>
        </table>
        <br />
        <table style={{ border: 'none', width: '100%' }}>
          <tr>
            <th>Correlation Matrix</th>
            <th>Customer Satisfaction</th>
          </tr>
          <tr>
            <td>
              <img alt="Chart" src="/latam/distributionmatrix.png" />
            </td>
            <td>
              <img alt="Chart" src="/latam/customersatisfaction.png" />
            </td>
          </tr>
        </table> */}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const workspaces = state[DuckMainData.namespace];
  return { workspaces };
};

const mapDispatchToProps = {
  getWorkspaces: DuckMainData.triggers.get
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuickSightDashboard);
